'use client';
export * from '../utils/splash';
